/* eslint-disable no-mixed-operators, no-useless-escape */
import React from 'react'
export const phoneNumberRegex = /^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/
export const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

export const phnFormatConversionRegex = /[^a-z0-9+]/g

export const emailCheckRegex = (value) => {

  return !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
}
export const titleCaseConversion = (string) => {
  var sentence = string.toLowerCase().split(' ')
  for (var i = 0; i < sentence.length; i++) {
    sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1)
  }
  var convertedSentence = sentence.join(' ')
  return convertedSentence
}
export const formateDate = (date) => {
  var event = new Date(date)
  let convertedDate = JSON.stringify(event)
  convertedDate = convertedDate.slice(1, 11)
  return convertedDate
}
export const status = [
  { label: 'Active', value: true },
  { label: 'Inactive', value: false},
]
export const booleanList = [
  { label: 'N/A', value: 'na' },
  { label: 'YES', value: 'yes' },
  { label: 'NO', value: 'no' },
]
export const showGrade =[
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
]
export const stockSector = [
  { label: '----Select----', value: '----Select----' },
  { label: 'Consumer Cyclical', value: 'Consumer Cyclical' },
  { label: 'Industrials', value: 'Industrials' },
  { label: 'Basic Materials', value: 'Basic Materials' },
  { label: 'Consumer Defensive', value: 'Consumer Defensive' },
  { label: 'Healthcare', value: 'Healthcare' }
]
export const subIndustry = [
  { label: '----Select----', value: '----Select----' },
  { label: 'Aerospace & Defense', value: 'Aerospace & Defense' },
  { label: 'Airlines', value: 'Airlines' },
  { label: 'Airports & Air Services', value: 'Airports & Air Services' },
  { label: 'Business Equipment', value: 'Business Equipment' },
  { label: 'Business Services', value: 'Business Services' }
]
export const exchange = [
  { label: 'OTCP', value: 'OTCP' },
  { label: 'OTCBB', value: 'OTCBB' },
  { label: 'OTC MARKETS', value: 'OTC MARKETS' },
  { label: 'OTC GREY MARKET', value: 'OTC GREY MARKET' },
  { label: 'OTC', value: 'OTC' },
  { label: 'NYSE', value: 'NYSE' }
]
export const grade = [
  { label: 'N/A', value: 'NA' },
  { label: 'A', value: 'A' },
  { label: 'B', value: 'B' },
  { label: 'C', value: 'C' },
  { label: 'D', value: 'D' },
  { label: 'F', value: 'F' }
]
export const growth = [
  { label: 'N/A', value: 'na' },
  { label: 'SLOW', value: 'slow' },
  { label: 'CLASSIC', value: 'classic' },
  { label: 'AGRESSIVE', value: 'aggressive' },
  { label: 'SPECULATIVE', value: 'speculative' },
]

export const master = [
  { label: '----Select----', value: '----Select----' },
  { label: 'Tata Consultancy Services', value: 'Tata Consultancy Services/A' },
  { label: 'Alliance Cornhill', value: 'Alliance Cornhill' },
  { label: 'IBS Software', value: 'IBS Software' },
  { label: 'Infosys pvt Limited', value: 'Infosys pvt Limited' },
  { label: 'RR Donelley', value: 'RR Donelley' },
]

export const titleCase=(str)=> {
  return str.toLowerCase().split(' ').map(function(word) {
    return (word.charAt(0).toUpperCase() + word.slice(1))
  }).join(' ')
}

export const yearList =()=>{
  const newDate = new Date()
  const year = newDate.getFullYear()+5
  const yearArray =[]
  for (let i = 2005; i <= year; i++) {
    yearArray.push(i)
  }
  return yearArray
}

export const validateBarriers = (value) => {
  const barriersValues = getValues(booleanList)
  barriersValues.push('Y')
  barriersValues.push('N')
  if(value){
    if (barriersValues.includes(value.trim().toUpperCase())) {
      return true
    }
    return false
  }
  return true
}

export const validateGrowthType = (value) => {
  const growthValues = getValues(growth)
  if(value){
    if (growthValues.includes(value.trim().toUpperCase())) {
      return true
    }
    return false
  }
  return true
}

export const getValues = (list) => {
  const values = []
  list.map(element => {
    values.push(element.value.toUpperCase())
    return element
  })
  return values
}

export const BarriersMap = {
  'y': 'Yes',
  'n': 'No',
  'na': 'NA',
  'yes': 'Yes',
  'no' : 'No'
}

export const getLoader=()=>{
  return (
    <div className="overlay">
      <div className="lds-ripple"><div></div><div></div></div>
    </div>
  )
}


export const uuidv4=()=> {
  let d = new Date().getTime()//Timestamp
  let d2 = (performance && performance.now && (performance.now()*1000)) || 0//Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = Math.random() * 16//random number between 0 and 16
    if(d > 0){//Use timestamp until depleted
      r = (d + r)%16 | 0
      d = Math.floor(d/16)
    } else {//Use microseconds since page-load if supported
      r = (d2 + r)%16 | 0
      d2 = Math.floor(d2/16)
    }
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
}
export const numberWithCommas=(x)=> {
  if(x.toString().indexOf('.')>=0){
    const numberArray=x.toString().split('.')
    if(numberArray.length>1){
      numberArray[0]=numberArray[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return numberArray[0]+'.'+numberArray[1]
    }
  }
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
